import React, { useEffect, useMemo, useState } from 'react'
import '../../../Assets/Css/AddProject.scss'
import { customStyle } from '../../../Components/Style'
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { connect } from 'react-redux'
import { addClient, getClients, updateClients } from '../../../Services/Clients/action'
import { toast } from 'react-toastify'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";
import { addProject, addProjectMilestones, deleteProjectMilestones, getProjectMilestones, getprojects, updateProject, updateProjectMilestones } from '../../../Services/Project/action';
import { getDepartments } from '../../../Services/Department/action';
import { getCurrencyList } from '../../../Services/Invoices/action';
import { getUsers } from '../../../Services/Users/action';
import { addTaskStatus, deleteTaskStatus, getTaskStatus, updateTaskStatus } from '../../../Services/Task/action';
import AddTaskStatusModal from '../../../Components/AddTaskStatusModal';
import AddProjectMilestonesModal from '../../../Components/AddProjectMilestonesModal';
import UserAvatar from 'react-user-avatar';
import { useDispatch } from 'react-redux';


const ProjectCategory = [
    { value: 'Design', label: 'Design' },
    { value: 'Development', label: 'Development' },
    { value: 'Research And Development', label: 'Research And Development' },
];

const ProjectStatus = [
    { value: 'In Progress', label: 'In Progress', color: '#00B5FF' },
    { value: 'Not Started', label: 'Not Started', color: 'gray' },
    { value: 'On Hold', label: 'On Hold', color: '#F5C308' },
    { value: 'Cancelled', label: 'Cancelled', color: '#D21010' },
    { value: 'Finished', label: 'Finished', color: '#679C0D' }
];

const OptionRenderer = ({ data }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <UserAvatar name={data?.label} style={{
                textTransform: 'uppercase',
                color: 'white',
                marginRight: '10px',
                fontSize: '14px',
                borderRadius: '50%',
            }} size={30} color="#5757fe" />
            {/* <FaUserCircle
                style={{
                    width: '20px',
                    height: '20px',
                    color: '#ced4da',
                    marginRight: '10px'
                }}
            /> */}
            <span>{data.label}</span>
        </div>
    );
};

const AddUpdateProject = (props) => {
    const location = useLocation();
    const projectData = location?.state?.data?.allData;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = location?.state?.data?.allData;
    const [isUpdate, setIsUpdate] = useState(false);
    const [progress, setProgress] = useState(0);
    const [showDetails, setShowDetails] = useState(false);
    const [addTaskStatusmodal, setAddTaskStatusModal] = useState(false);
    const [addProjectMilestonesModal, setAddProjectMilestonesModal] = useState(false);
    const { employeeId } = useParams();

    const fetchData = async () => {
        await props?.getDepartments();
        await props?.getCurrencyList();
        await props?.getUsers({ module: 'department' });
        await props?.getClients("");
        await props?.getTaskStatus();
        await props?.getProjectMilestones();
    };
    useEffect(() => {
        fetchData();
    }, [])

    const openTaskStatusModal = () => setAddTaskStatusModal(true);
    const closeTaskStatusModal = async () => {
        setAddTaskStatusModal(false);
        await fetchData();
        dispatch({ type: "CLEAR_ADD_TASK_STATUS" });
    }

    const openProjectMilestonesModal = () => setAddProjectMilestonesModal(true);
    const closeProjectMilestonesModal = async () => {
        setAddProjectMilestonesModal(false);
        await fetchData();
        dispatch({ type: "CLEAR_ADD_PROJECT_MILESTONES" })
    }
    const toggleDetails = () => {
        setShowDetails(prev => !prev);
    };

    const handleRangeChange = (event) => {
        setClientData((prevData) => ({
            ...prevData,
            completion_status: Number(event.target.value)
        }))
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData((preVal) => ({
            ...preVal,
            [name]: value
        }))

    }

    const [taskStatusList, setTaskStatusList] = useState([]);
    const [projectMilestonesList, setProjectMilestonesList] = useState([]);

    useEffect(() => {
        const sortedStatuses = props.taskStatus
            ?.filter(item =>
                item?.taskStatus?.some(status => status?.project_id == data?.id)
            )
            ?.sort((a, b) => {
                const aOrder = a?.taskStatus?.find(s => s.project_id == data?.id)?.sort_order || 0;
                const bOrder = b?.taskStatus?.find(s => s.project_id == data?.id)?.sort_order || 0;
                return aOrder - bOrder;
            });

        const filteredMilestones = props?.projectMilestones?.filter(item => item?.milestone?.find(milestone => milestone?.project_id == data?.id))

        setProjectMilestonesList(prev =>
            prev.length === 0 ? filteredMilestones : prev
        )
        setTaskStatusList(prev =>
            prev.length === 0 ? sortedStatuses : prev
        );
    }, [props?.taskStatus, data?.id]);

    const ProjectMilestones = projectMilestonesList?.map((item) => {
        return {
            label: item?.name,
            value: item?.id,
        }
    });


    const TaskStatus = taskStatusList?.map((item) => {
        return {
            label: item?.name,
            color_code: item?.color_code,
            value: item?.id,
        }
    });

    const Currency = props?.currencylist?.map((item) => {
        return {
            label: `${item?.symbol} (${item?.code})`,
            value: `${item?.symbol} (${item?.code})`,
        }
    });

    const Department = props?.department?.map((item) => {
        return {
            label: item?.name,
            value: item?.id,
        }
    });


    const assignedUserIds = data?.projectUserMap?.map(user => user?.userProjectMap?.id) || [];

    const ProjectAssignedTo = data
        ? props?.users
            ?.filter(user => !assignedUserIds.includes(user?.id))
            ?.map(user => ({
                label: user?.name,
                value: user?.id
            }))
        : props?.users?.map(user => ({
            label: user?.name,
            value: user?.id
        }));


    const Clients = props?.clients?.rows?.map((item) => {
        return {
            label: item?.name,
            value: item?.id,
        }
    });

    const AddedBy = props?.users?.map((item) => {
        return {
            label: item?.name,
            value: item?.id,
        }
    });
    const getInitialAssignedUsers = () => {
        if (data && Array.isArray(data?.projectUserMap)) {
            return data?.projectUserMap?.map((item) => {
                if (item?.userProjectMap) {
                    return {
                        label: item?.userProjectMap?.name,
                        value: item?.userProjectMap?.id,
                    };
                }
                return null;
            }).filter(Boolean);
        } else {
            const currentUserId = employeeId;
            const currentUser = props?.users?.find(user => user?.id == currentUserId);
            if (currentUser) {
                return [{
                    label: currentUser?.name,
                    value: currentUser?.id,
                }];
            }
            return [];
        }
    };

    const initialState = {
        code: data?.code || '',
        projectname: data?.name || '',
        start_date: data?.start_date || null,
        deadline: data?.deadline || null,
        no_project_deadline: data ? data?.deadline ? false : true : false,
        project_category: ProjectCategory?.find((item) => item?.value == data?.project_category) || null,
        department: Department?.find((item) => item?.value == data?.department?.name) || null,
        assignedTo: getInitialAssignedUsers(),
        clients: Clients?.find((item) => item?.value == data?.client?.id) || null,
        status: ProjectStatus?.find((item) => item?.value == data?.status) || { value: 'Not Started', label: 'Not Started', color: 'gray' },
        completion_status: Number(data?.completion_status) || 0,
        calculate_through_tasks: data ? data?.completion_status ? false : true : false,
        summary: data?.summary || '',
        currency: Currency?.find((item) => item?.value == `${data?.currency?.symbol} (${data?.currency?.code})`) || null,
        budget: data?.budget || '',
        hours: data?.hours || 0,
        added_by: data ? props?.users?.filter((item) => item?.id == data?.added_by)?.map((item) => {
            return {
                label: item?.name,
                value: item?.name,
            };
        }) : (AddedBy?.find((item) => item?.value == data?.added_by) || null),
        manual_timelogs: data ? data?.manual_timelogs ? true : false : false,
        send_notification: data ? data?.send_notification ? true : false : false,
        enable_microboard: data ? data?.enable_microboard ? true : false : false,
        taskStatus: TaskStatus?.find(item => item?.value == data?.default_task_status_id) || null,
        projectMilestones: ProjectMilestones?.find(item => item?.value == data?.projectMilestones?.id) || null
    }

    const [clientData, setClientData] = useState(initialState);

    useEffect(() => {
        if (taskStatusList.length > 0) {
            const updatedTaskStatus = taskStatusList
                .map((item) => ({
                    label: item?.name,
                    color_code: item?.color_code,
                    value: item?.id,
                }))
                .find((item) => item?.value == data?.default_task_status_id);

            setClientData((prev) => ({
                ...prev,
                taskStatus: updatedTaskStatus || null,
            }));
        }
    }, [taskStatusList, data]);

    const handleSubmit = async () => {
        try {
            if (!clientData?.code || !clientData?.projectname || !clientData?.start_date || (!clientData?.no_project_deadline && !clientData?.deadline) || !clientData?.taskStatus?.value) {
                toast.error('Please fill all the required fields');
                return;
            }

            const shortCodeExists = props?.project?.some((item) =>
                item.code === clientData?.code && item.id !== projectData?.id
            );

            if (shortCodeExists) {
                toast.error('Short code is already exist');
                return;
            }

            const postData = {
                ...clientData,
                department_id: clientData?.department?.value,
                employee_id: props?.users
                    ?.filter(user => clientData.assignedTo?.some(assigned => assigned.value === user.id))
                    ?.map(user => user.id),
                client_id: clientData?.clients?.[0]?.value,
                currency_id: props?.currencylist?.filter((item) => `${item?.symbol} (${item?.code})` === clientData?.currency?.value)[0]?.id,
                project_category: clientData?.project_category?.value,
                status: clientData?.status?.value,
                name: clientData?.projectname,
                added_by: props?.users?.filter((item) => item?.name == clientData?.added_by?.value)?.[0]?.id,
                // milestone_id: clientData?.projectMilestones?.value,
                taskStatusList,
                projectMilestonesList,
                default_task_status_id: clientData?.taskStatus?.value
            }
            let success = false;
            if (data) {
                const res = await props?.updateProject(data?.id, postData);
                success = res?.status === 200 || res?.success || true;
            } else {
                const res = await props.addProject(postData);
                success = res?.status === 200 || res?.success || true;
            }
            if (success) {
                navigate('/project/employeeproject');
            }
        } catch (error) {
            console.error("Error in save data : ", error)
            toast.error(error);
        }
    }

    useEffect(() => {
        if (
            props.clients?.rows &&
            props.projectMilestones &&
            props.users &&
            props.currencylist &&
            props.department &&
            props.taskStatus
        ) {
            setClientData(prev => {
                if (Object.keys(prev).length === 0 || !prev.projectname) {
                    return { ...initialState };
                }
                return prev;
            });
            // setClientData({
            //     ...initialState
            // });
        }
    }, [
        props.clients,
        props.projectMilestones,
        props.users,
        props.currencylist,
        props.department,
        props.taskStatus
    ]);

    const content = <div className="addUpdateClient-main">
        <div className="page-title">
            <h4> {location?.pathname?.includes("add") ? "Add" : "Update"} Project</h4>
            <div className="edit-btn">
                <button
                    type="button"
                    className="custom-btn"
                    onClick={() => navigate(-1)}
                >
                    {props.loading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        "Cancel"
                    )}
                </button>

                <button
                    type="button"
                    className="custom-btn"
                    onClick={handleSubmit}
                >
                    {props.loading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            className="custom-spinner"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        "Save"
                    )}
                </button>
            </div>
        </div>

        <div className="content-part">
            <div className="row">
                <div className="col-lg-12">
                    <div className="left-part p-4">
                        <div className="custom-row">
                            <div className="add-project-detail">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Short Code <span style={{ color: 'red' }}>*</span></h6>
                                            <input type="text" className="input-css" name='code' disabled={props.loading} value={clientData.code} placeholder="Project unique short code" onChange={handleChange} />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Project Name <span style={{ color: 'red' }}>*</span></h6>
                                            <input type="text" className="input-css" name='projectname' disabled={props.loading} value={clientData.projectname} placeholder='Write a project name' onChange={handleChange} />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Start Date <span style={{ color: 'red' }}>*</span></h6>
                                            <DatePicker
                                                styles={customStyle}
                                                selected={clientData?.start_date ? new Date(clientData?.start_date) : null}
                                                placeholderText="Select Date"
                                                onChange={(date) => {
                                                    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                        .toISOString()
                                                        .split('T')[0];
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        start_date: localDate,
                                                    }));
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                name="transaction_date"
                                                disabled={props.loading}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    {!clientData.no_project_deadline && (

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Deadline <span style={{ color: 'red' }}>*</span></h6>
                                                <DatePicker
                                                    styles={customStyle}
                                                    selected={clientData.deadline ? new Date(clientData.deadline) : null}
                                                    placeholderText="Select Date"
                                                    onChange={(date) => {
                                                        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                                                            .toISOString()
                                                            .split('T')[0];
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            deadline: localDate,
                                                        }));
                                                    }}
                                                    dateFormat="dd-MM-yyyy"
                                                    name="transaction_date"
                                                    disabled={props.loading}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                    )}
                                    <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
                                        <div className="radiobtn">
                                            <input type="checkbox" value={clientData.no_project_deadline}
                                                defaultChecked={
                                                    data ? data?.deadline ? false : true : false
                                                }
                                                onChange={(e) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        no_project_deadline: e.target.checked
                                                    }))
                                                }} />
                                            <lable className="label">There is no project deadline</lable>
                                        </div>
                                    </div>

                                    {clientData.no_project_deadline && (
                                        <div className='col-lg-4 col-md-4 col-sm-6'></div>
                                    )}

                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Project Category</h6>
                                            <Select
                                                options={ProjectCategory}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={clientData.project_category}
                                                placeholder="---"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        project_category: val
                                                    }))
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Department</h6>
                                            <Select
                                                options={Department}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={clientData.department}
                                                placeholder="---"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        department: val
                                                    }))
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Assigned To</h6>
                                            <Select
                                                options={ProjectAssignedTo}
                                                getOptionLabel={(option) => (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                        <span>{option.label}</span>
                                                        {option.id === props.user.id && (
                                                            <span style={{ fontSize: '0.8em', color: '#fff', backgroundColor: '#888', padding: '0px 4px 0px 4px', borderRadius: '4px' }}>It's you</span>
                                                        )}
                                                    </div>
                                                )}
                                                getOptionValue={option => option.value}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                        width: '100%',
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: 'none',
                                                        border: '1px solid #ced4da',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#6c757d',
                                                    }),

                                                }}
                                                value={clientData.assignedTo}
                                                placeholder="---"
                                                onChange={(selectedOptions) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        assignedTo: selectedOptions || []
                                                    }));
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                                isSearchable
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="input-group">
                                            <h6 className='label'>Clients</h6>
                                            <Select
                                                options={Clients}
                                                getOptionLabel={option => <OptionRenderer data={option} />}
                                                getOptionValue={option => option.value}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                        width: '100%',
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: 'none',
                                                        border: '1px solid #ced4da',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#6c757d',
                                                    }),

                                                }}
                                                value={clientData.clients}
                                                placeholder="---"
                                                onChange={(selectedOptions) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        clients: selectedOptions
                                                    }));
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                                isSearchable
                                                isMulti
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Project Status</h6>
                                            <Select
                                                options={ProjectStatus}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                        width: '100%',
                                                    }),
                                                    control: (provided) => ({
                                                        ...provided,
                                                        boxShadow: 'none',
                                                        border: '1px solid #ced4da',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#6c757d',
                                                    }),
                                                }}
                                                value={clientData.status}
                                                placeholder="---"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        status: val
                                                    }));
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                                isSearchable
                                                getOptionLabel={(e) => (
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span
                                                            style={{
                                                                height: '12px',
                                                                width: '12px',
                                                                backgroundColor: e.color,
                                                                borderRadius: '50%',
                                                                display: 'inline-block',
                                                                marginRight: '10px',
                                                                marginLeft: '10px'
                                                            }}
                                                        />
                                                        {e.label}
                                                    </div>
                                                )}
                                                getOptionValue={(e) => e.value}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4">
                                        <div className="input-group">
                                            <h6 className='label'>Project Completion Status</h6>
                                            <input
                                                type="range"
                                                className="form-range"
                                                id="customRange1"
                                                min="0"
                                                max="100"
                                                value={clientData.completion_status}
                                                onChange={handleRangeChange}
                                                style={{
                                                    marginBottom: "-15px",
                                                }}
                                            />
                                            {clientData.completion_status}%
                                        </div>
                                    </div>

                                    {/* <div className="col-lg-4 col-md-4 col-sm-6 due_date_radio">
                                        <div className="radiobtn">
                                            <input type="checkbox" value={clientData.calculate_through_tasks}
                                                onChange={(e) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        calculate_through_tasks: e.target.checked
                                                    }))
                                                }} />
                                            <lable className="label">Calculate progess through tasks</lable>
                                        </div>
                                    </div> */}

                                    <div className="col-lg-6 task-catagory">
                                        <div className="input-group">
                                            <h6 className="label">Task Status <span style={{ color: 'red' }}>*</span></h6>
                                            <Select
                                                formatOptionLabel={(option) => (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span
                                                            style={{
                                                                height: 10,
                                                                width: 10,
                                                                borderRadius: '50%',
                                                                backgroundColor: option.color_code || '#000',
                                                                display: 'inline-block',
                                                            }}
                                                        />
                                                        <span>{option.label}</span>
                                                    </div>
                                                )}
                                                options={TaskStatus}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={clientData?.taskStatus}
                                                placeholder="---"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        taskStatus: val,
                                                    }));
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#5757fe',
                                                        primary: '#5757fe',
                                                    },
                                                })}
                                            />
                                        </div>
                                        <button onClick={openTaskStatusModal}>Manage</button>
                                    </div>

                                    <div className="col-lg-6 task-catagory">
                                        <div className="input-group">
                                            <h6 className="label">Milestones</h6>
                                            {/* <Select
                                                options={ProjectMilestones}
                                                styles={{
                                                    ...customStyle,
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 2,
                                                    }),
                                                }}
                                                value={clientData.projectMilestones}
                                                placeholder="---"
                                                onChange={(val) => {
                                                    setClientData((preVal) => ({
                                                        ...preVal,
                                                        projectMilestones: val,
                                                    }));
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#5757fe',
                                                        primary: '#5757fe',
                                                    },
                                                })}
                                                /> */}
                                            <button onClick={openProjectMilestonesModal} style={{ width: '100%' }}>Manage</button>
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="note-part">
                                            <h6 className="label">Project Summary</h6>
                                            <div className="editor-custom">
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={data?.summary || ""}
                                                    onReady={editor => {
                                                        console.log('Editor is ready to use!', editor);
                                                    }}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        console.log({ event, editor, data });
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            summary: data
                                                        }))
                                                    }}
                                                    onBlur={(event, editor) => {
                                                        console.log('Blur.', editor);
                                                    }}
                                                    onFocus={(event, editor) => {
                                                        console.log('Focus.', editor);
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <h5 className='other-detail-divider'>
                                    Other Details
                                    <span onClick={toggleDetails} style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '30px' }}>
                                        {showDetails ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                    </span>
                                </h5>
                                {showDetails && (
                                    <div className="row">

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Currency</h6>
                                                <Select
                                                    options={Currency}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                    value={clientData?.currency || ""}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            currency: val
                                                        }))
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Project Budget</h6>
                                                <input type="text" className="input-css" name='budget' disabled={props.loading} value={clientData.budget} placeholder="e.g. 10000" onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Hours Estimate (In Hours)</h6>
                                                <input type="number" className="input-css" name='hours' disabled={props.loading} value={clientData.hours} placeholder="e.g. 500" onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-6">
                                            <div className="radiobtn">
                                                <input type="checkbox" value={clientData.manual_timelogs}
                                                    defaultChecked={
                                                        data ? data?.manual_timelogs ? true : false : false
                                                    }
                                                    onChange={(e) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            manual_timelogs: e.target.checked
                                                        }))
                                                    }} />
                                                <lable className="label">Allow Mannual time logs</lable>
                                            </div>
                                        </div>

                                        {/* <div className="col-lg-4 col-md-4 col-sm-6">
                                            <div className="radiobtn">
                                                <input type="checkbox" value={clientData.send_notification}
                                                    defaultChecked={
                                                        data ? data?.send_notification ? true : false : false
                                                    }
                                                    onChange={(e) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            send_notification: e.target.checked
                                                        }))
                                                    }} />
                                                <lable className="label">Send task notification to client</lable>
                                            </div>
                                        </div> */}

                                        <div className="col-lg-4">
                                            <div className="input-group">
                                                <h6 className='label'>Added By</h6>
                                                <Select
                                                    options={AddedBy}
                                                    getOptionLabel={option => <OptionRenderer data={option} />}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                            width: '100%',
                                                        }),
                                                        control: (provided) => ({
                                                            ...provided,
                                                            boxShadow: 'none',
                                                            border: '1px solid #ced4da',
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            color: '#6c757d',
                                                        }),
                                                    }}
                                                    value={clientData.added_by}
                                                    placeholder="---"
                                                    onChange={(val) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            added_by: val
                                                        }));
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                    isSearchable
                                                />
                                            </div>
                                        </div>

                                        {/* <div className="col-lg-4 col-md-4 col-sm-6">
                                            <div className="radiobtn">
                                                <input type="checkbox" value={clientData.enable_microboard}
                                                    defaultChecked={
                                                        data ? data?.enable_microboard ? true : false : false
                                                    }
                                                    onChange={(e) => {
                                                        setClientData((preVal) => ({
                                                            ...preVal,
                                                            enable_microboard: e.target.checked
                                                        }))
                                                    }} />
                                                <lable className="label">Enable Miroboard</lable>
                                            </div>
                                        </div> */}

                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    return (
        <>
            {content}
            <AddTaskStatusModal isOpen={addTaskStatusmodal} onClose={closeTaskStatusModal} addTaskStatus={props?.addTaskStatus} taskStatus={props?.taskStatus} loading={props?.taskStatusLoading} deleteTaskStatus={props?.deleteTaskStatus} deleteLoading={props?.deleteLoading} updateTaskStatus={props?.updateTaskStatus} taskStatusList={taskStatusList} setTaskStatusList={setTaskStatusList} data={data} getTaskStatus={props?.getTaskStatus} addTaskStatusPayload={props?.addTaskStatusPayload} />

            <AddProjectMilestonesModal isOpen={addProjectMilestonesModal} onClose={closeProjectMilestonesModal} addProjectMilestones={props?.addProjectMilestones} projectMilestones={props?.projectMilestones} loading={props?.projectMilestoneLoading} deleteProjectMilestones={props?.deleteProjectMilestones} deleteLoading={props?.deleteLoading} updateProjectMilestones={props?.updateProjectMilestones} projectMilestonesList={projectMilestonesList} setProjectMilestonesList={setProjectMilestonesList} addProjectMilestonePayload={props?.addProjectMilestonePayload} />
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        loading: state.projectReducer.loading,
        project: state.projectReducer.project,
        currencylist: state.invoicesReducer.currencylist,
        department: state.departmentReducer.department,
        users: state.userReducer.users,
        clients: state.clientsReducer.clients,
        user: state.authenticationReducer.user,
        taskStatus: state.taskReducer.taskStatus,
        projectMilestones: state.projectReducer.projectMilestones,
        addTaskStatusPayload: state.taskReducer.addTaskStatus,
        taskStatusLoading: state.taskReducer.loading,
        addProjectMilestonePayload: state.projectReducer.addProjectMilestones,
        projectMilestoneLoading: state.projectReducer.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getprojects: () => {
            dispatch(getprojects());
        },
        getDepartments: () => {
            dispatch(getDepartments());
        },
        getCurrencyList: () => {
            dispatch(getCurrencyList());
        },
        getUsers: (options) => {
            dispatch(getUsers(options));
        },
        getClients: () => {
            dispatch(getClients(""));
        },
        addProject: (data) => {
            dispatch(addProject(data))
        },
        updateProject: (id, data) => {
            dispatch(updateProject(id, data))
        },
        getTaskStatus: () => {
            dispatch(getTaskStatus())
        },
        addTaskStatus: (data) => {
            dispatch(addTaskStatus(data))
        },
        updateTaskStatus: (id, data) => {
            dispatch(updateTaskStatus(id, data))
        },
        deleteTaskStatus: (id) => {
            dispatch(deleteTaskStatus(id))
        },
        getProjectMilestones: () => {
            dispatch(getProjectMilestones())
        },
        addProjectMilestones: (data) => {
            dispatch(addProjectMilestones(data))
        },
        updateProjectMilestones: (id, data) => {
            dispatch(updateProjectMilestones(id, data))
        },
        deleteProjectMilestones: (id) => {
            dispatch(deleteProjectMilestones(id))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateProject);